import { IPreguntaCheckpointDTO, PreguntaCheckpointDTO } from "./PreguntaCheckpoint.DTO";
import { Nilable } from "@shared/utils";

export interface IEncuestaCheckpointDTO {
    id: number;
    questions: IPreguntaCheckpointDTO[];
}

export class EncuestaCheckpointDTO {
    public id = 0;
    public preguntas: PreguntaCheckpointDTO[] = [];

    constructor(json: Nilable<Partial<IEncuestaCheckpointDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IEncuestaCheckpointDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.questions != null) {
            this.preguntas = json.questions.map(pregunta => new PreguntaCheckpointDTO(pregunta));
        }
    }
}
